<template>
  <div class="card" v-if="filters" style="padding-top:30px">
    <!-- {{filters[3]}} -->
    <div class="card-header">
      <h4 v-if="title">{{ title }}</h4>
      <h4 v-else>{{$helper.getWord('filter')}}</h4>
      <template v-if="computedIcon">
        <div class="col-md-1" v-if="ticon">
          <i
            class="fas fa-chevron-down float-right align-middle btn btn-circle"
            @click="toggleIcon"
          ></i>
        </div>
        <div class="col-md-1" v-if="!ticon">
          <i class="fas fa-chevron-up float-right align-middle btn btn-circle" @click="toggleIcon"></i>
        </div>
      </template>
    </div>

    <div :style="{ display: ticon ? 'block' : 'none' }">
      <div class="card-body">
        <div class="form-row">
          <template v-for="filter in filters">
            <template v-if="filter.fieldType == type.DateRange">
              <div :class="computedColsClass" :key="filter.from.id">
                <label>{{ filter.from.placeholder }}</label>
                <DatePicker
                  :id="filter.from.id + gridId"
                  v-model="filter.from.value"
                  :key="filter.from.id"
                  :value="filter.from.value"
                  @input="changeEvent"
                  @clickEvent="resetSyncDate(filter)"
                />
              </div>

              <div :class="computedColsClass" :key="filter.to.id">
                <label>{{ filter.to.placeholder }}</label>
                <DatePicker
                  :id="filter.to.id + gridId"
                  v-model="filter.to.value"
                  :key="filter.from.id"
                  :value="filter.to.value"
                  @input="changeEvent"
                  @clickEvent="syncDate(filter)"
                />
              </div>
            </template>

            <template v-else-if="filter.fieldType == type.AmountRange">
              <div :class="computedColsClass" :key="filter.from.id">
                <label>{{ filter.from.placeholder }}</label>
                <input
                  type="number"
                  :id="filter.from.model + gridId"
                  class="form-control"
                  v-model="filter.from.value"
                  @input="changeEvent"
                />
              </div>

              <div :class="computedColsClass" :key="filter.to.id">
                <label>{{ filter.to.placeholder }}</label>
                <input
                  type="number"
                  :id="filter.to.model + gridId"
                  class="form-control"
                  v-model="filter.to.value"
                  @input="changeEvent"
                />
              </div>
            </template>
            <template v-else-if="filter.fieldType == type.SelectBox">
              <div :class="computedColsClass" :key="filter.id">
                <label>{{ filter.placeholder }}</label>
                <select
                  class="form-control"
                  :id="filter.id"
                  v-model="filter.value"
                  @input="changeEvent"
                >
                  <!-- <option value="NULL">Not Matched</option>
                  <option value="NOT NULL">Matched</option>-->

                  <template v-for="(option, index) in filter.list">
                    <option
                      :value="option.VAL"
                      :key="index"
                      :selected="filter.selectedIndex === index"
                    >{{ option.DISPLAY }}</option>
                  </template>
                </select>
              </div>
            </template>
            <template v-else-if="filter.fieldType == type.Select2">
              <div :class="computedColsClass">
                <label>{{ filter.placeholder }}</label>
                <Select2Dropdown
                  v-if="filter.list"
                  :id="filter.id + gridId"
                  :gridId="gridId"
                  :class="'form-control'"
                  :list="filter.list"
                  v-model="filter.value"
                  :isAjax="false"
                  @input="changeEvent"
                  :value="filter.value"
                  :haveTitle="true"
                />
              </div>
            </template>
            
            <template v-else-if="filter.fieldType == type.TextBox">
              <div :class="computedColsClass" :key="filter.id" style="height: 46px;">
                <label>{{ filter.placeholder }}</label>
                <!-- <input type="text" class="form-control" /> -->
                <Textbox
                  :id="filter.id + gridId"
                  v-model="filter.value"
                  :value="filter.value"
                  @input="changeEvent"
                  :nolabel="true"
                />
              </div>
            </template>
            <template v-else>
              <div :class="computedColsClass" :key="filter.id">
                <label>{{ filter.placeholder }}</label>
                <!-- <input type="text" class="form-control" /> -->
                <TagsInput
                  :id="filter.id + gridId"
                  v-model="filter.value"
                  :value="filter.value"
                  @input="changeEvent"
                />
              </div>
            </template>
          </template>
        </div>
      </div>

      <div class="card-footer">
        <button class="btn btn-primary m-2" v-if="hasNew" @click="$router.push(newLink)">{{$helper.getWord('new')}}</button>
        <button
          class="btn btn-primary m-2"
          :disabled="!isViewMode"
          @click="getSlickGrid"
          v-if="isMainGrid"
        >{{$helper.getWord('find now')}}</button>

        <button
          class="btn btn-primary m-2"
          :disabled="!isViewMode"
          @click="actionSetIsClearFilter(true)"
          v-if="isMainGrid"
        >{{$helper.getWord('clear')}}</button>
        <button
          v-if="isMainGrid&&isExport"
          class="btn btn-primary m-2"
          :disabled="this.grid == null || !(this.grid.totalRows > 0)"
          @click="toggleExport"
        >Export</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import filterType from "@/assets/js/filterType";
import TagsInput from "@/components/TagsInput";
import DatePicker from "@/components/DatePicker";
import Select2Dropdown from "@/components/Select2Dropdown";
import helper from "@/vueHelper";

export default {
  name: "datafilter",
  props: {
    gridId: {
      type: String,
      required: true
    },
    title: String,
    cols: Number,
    icon: {
      default: undefined,
      type: Boolean
    },
    isMainGrid: {
      default: true,
      type: Boolean
    },
    hasNew: {
      type: Boolean,
      default: false
    },
    newLink: String,
    isCustomInit: Boolean,
    isExport: {
      default: true,
      type: Boolean
    }
  },
  components: {
    TagsInput,
    DatePicker,
    Select2Dropdown
  },
  data() {
    return {
      name: "",
      selected: "bar",
      isClearDate: false,
      ticon: true,
      haveChange: false,
      filters: null,
      type: filterType,
      filterItem: {}
    };
  },
  mounted() {
    if(this.grid&&!this.haveChange){

      this.initFilter(this.grid);
    }
  },
  updated() {},
  computed: {
    ...mapGetters("grid", ["getGrid", "getViewMode"]),
    ...mapGetters("filters", ["getFilter", "getIsClearFilter"]),

    computedIcon() {
      if (this.icon == undefined) {
        return true;
      }

      return this.icon;
    },
    computedColsClass() {
      if (this.cols == 2) {
        return "form-group col-md-6";
      } else {
        //default
        return "form-group col-md-4";
      }
    },
    isViewMode() {
      return this.getViewMode;
    },
    grid() {
      return this.getGrid[this.gridId];
    },
    //template
    getGridData() {
      //name = this.getGrid["#myGrid01"]
      //val = this.getGrid["#fkcarl"].val
      //this.grid = new Grid(val.name, valView, val.columns, val.options);
      return this.getGrid;
    }
  },
  watch: {
    grid: function(val) {
      if (!val) {
        return;
      }
      this.initFilter(val);
      
    },
    getIsClearFilter: function(val) {
      if (val) {
        this.clearFilter();
      }
    },
    getFilter: {
      handler: function(filter) {
        if (this.isMainGrid) return;
        if (!filter) return;
        if (!this.filters) return;
        let val = _.cloneDeep(filter);

        this.filters.forEach(obj => {
          if (obj.fieldType == filterType.DateRange) {
            if (this.isValid(val[obj.from.id])) {
              obj.from.value = val[obj.from.id];
            }
            if (this.isValid(val[obj.to.id])) {
              obj.to.value = val[obj.to.id];
              // console.log(obj.to.value);
              // console.log(obj.to.value);
            }
          }
          // else if (obj.fieldType == filterType.SelectBox) {
          //   if (this.isValid(val[obj.id])) {
          //     obj.value = val[obj.id];
          //   }
          // }
          else {
            if (this.isValid(val[obj.id])) {
              obj.value = val[obj.id];
            }
          }
        });
      },
      deep: true
    },
    filters: {
      handler(val) {
        //also sync to vuex filter item
        if (val) {
          let dailyControlFilter = val.find(
            o => o.model.toUpperCase() == "DAILY_CONTROL_ID"
          );
          let dailyControlVal =
            dailyControlFilter && dailyControlFilter.value
              ? dailyControlFilter.value
              : null;

          let cloneFilter = _.cloneDeep(val);
          //get all required fields
          let createDatetimeFilter = cloneFilter.find(
            o => o.model.toUpperCase() === "CREATED_DATETIME"
          );
          let createDatetimeVal =
            createDatetimeFilter &&
            createDatetimeFilter.from.value &&
            createDatetimeFilter.to.value
              ? true
              : false;

          console.log(createDatetimeVal);

          if (dailyControlVal || createDatetimeVal) {
            //if daily control has value no need to check date la, so clear
            for (var i = 0; i < cloneFilter.length; i++) {
              let type = cloneFilter[i].fieldType;
              if (type == filterType.DateRange && cloneFilter[i].isRequired) {
                if (!this.isClearDate) {
                  cloneFilter[i].from.value = null;
                  cloneFilter[i].to.value = null;
                  val[i].from.value = null;
                  val[i].to.value = null;
                  this.isClearDate = true;
                }

                cloneFilter[i].isRequired = false;
              }
            }
            this.actionSetSelectRequestFilter({
              gridId: this.gridId,
              requestFilter: _.cloneDeep(cloneFilter)
            });
          } else {
            this.actionSetSelectRequestFilter({
              gridId: this.gridId,
              requestFilter: _.cloneDeep(val)
            });
          }
        }
      },
      deep: true
    },

    getViewMode: function(isView) {
      if (isView) {
        $(".slick-header-columns").css("pointer-events", "all");
      } else {
        $(".slick-header-columns").css("pointer-events", "none");
      }
    },

    getToggleGridResize: function(val) {
      if (val) {
        this.handleResize();
        this.actionSetToggleGridResize(false);
      }
    }
  },
  methods: {
    ...mapActions("grid", [
      "actionRequest",
      "actionExportExcel",
      "actionSetSelectRequestFilter"
    ]),
    ...mapActions("filters", [
      "actionSetFilters",
      "actionFindNow",
      "actionSetIsClearFilter",
      "actionResetData"
    ]),
    initFilter(val){
      let grid = _.cloneDeep(val);
      if (grid.filters && !this.haveChange) {
        //COPY VUEX OBJ NEED THIS METHOD

        this.filters = grid.filters.map(filter => {
          if (filter.fieldType == filterType.DateRange && filter.isRequired) {
            filter.from.value = moment().format("YYYY-MM-DD");
            filter.to.value = moment().format("YYYY-MM-DD");
          }

          if (this.isCustomInit && grid.filterItem) {
            Object.entries(grid.filterItem).forEach(([key, value]) => {
              if (key == filter.model) {
                if (filter.fieldType == filterType.DateRange) {
                  filter.from.value = value.from;
                  filter.to.value = value.to;
                } else {
                  filter.value = value;
                }
              }
            });
          }
          return filter;
        });

        this.haveChange = true;
      }
    },
    toggleExport() {
      this.actionExportExcel({
        access_code: this.grid.gridId,
        page: this,
        isBlob: true
      });
    },
    isValid(str) {
      if (str || str == "") {
        return true;
      }

      if (!str) {
        return false;
      }
    },
    clearFilter() {
      this.filters.forEach(filter => {
        let type = filter.fieldType;
        if (type == filterType.Tags) {
          filter.value = null;
        } else if (type == filterType.DateRange) {
          filter.from.value = null;
          filter.to.value = null;
        } else if (type == filterType.SelectBox) {
          filter.value = null;
        } else if (type == filterType.AmountRange) {
          filter.from.value = null;
          filter.to.value = null;
        } else if (type) {
          filter.value = null;
        }
      });
      this.actionResetData();
    },

    switchView: function(event, selectedIndex) {},
    getSlickGrid() {
      //filter all grid

      // console.log(this.filters.filter(o=>o.isRequired))
      helper.findNow(this);
      //this.$parent.$refs.updateSlickGrid.getData();
    },
    toggleIcon() {
      this.ticon = !this.ticon;
    },

    changeEvent() {
      if (!this.isMainGrid) return;
      this.actionSetFilters(this.filters);
    },
    syncDate(filter) {
      if (!filter.haveSyncDate) {
        filter.to.value = filter.from.value;
        filter.haveSyncDate = true;
      }
    },
    resetSyncDate(filter) {
      if (filter.haveSyncDate) {
        filter.haveSyncDate = false;
      }
    }
  }
};
</script>

